module.exports = __webpack_public_path__ + "img/izzy.f82980d4.jpg";